export const NOTIFICATION = 'notification';
export const INVITATION = 'invitation';
export const SHOW_ALL_NOTIFICATIONS = 'show_all_notifications';
export const SAVE_SCROLL = 'save_scroll';
export const RESTORE_SCROLL = 'restore_scroll';
export const RESET_SCROLL = 'reset_scroll';